module.exports = __webpack_public_path__ + "img/Mounting-Product.578e3dfd.jpg";